<template>
  <section class="c-extract-transactions">
    <div class="c-extract-transactions__wrapper-empty">
      <div class="has-text-centered">
        <base-icon
          width="131"
          height="107"
          name="carteira-transacao-error"
          class="c-extract-transactions__wallet-image"
        />
        <p class="c-extract-transactions__wallet-empty">
          <b>Não foi possivel carregar<br />suas transações!</b>
        </p>
      </div>
    </div>
  </section>
</template>

<script>
export default {}
</script>

<style lang="scss">
.c-extract-transactions {
  margin-top: 18px;
  padding-bottom: 20px;
  @media (min-width: $tablet) {
    height: calc(80vh - 60px);
  }

  &__header {
    margin-bottom: 18px;
    text-align: center;
  }

  &--margin-bottom {
    margin-bottom: 100px;
  }

  &__wrapper {
    max-width: 660px;
    margin: 0 auto 18px;
  }

  &__wrapper-empty {
    margin: 50px auto 0px;
    @media (min-width: $tablet) {
      margin: 0px auto;
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }
  }

  &__wallet-image {
    @media (min-width: $tablet) {
      width: 200px;
      height: 165px;
    }
  }

  &__wallet-empty {
    margin: 15px auto;
  }
}

.new-menu {
  .c-extract-transactions {
    @media (min-width: $tablet) {
      min-height: calc(80vh - 60px);
      height: auto !important;
    }
  }
}
</style>
